<template>
  <div
    class="add-box"
    :class="`${!!design ? `design-${design}` : ''} ${mobile ? 'mobile' : ''}`"
    :style="`height: ${height}`"
    @click="execute"
  >
    <i v-if="plus" class="fal fa-plus"></i>
    <p>{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    text: { type: String, required: true },
    plus: { type: Boolean, default: true },
    design: String,
    height: String,
    mobile: { type: Boolean, default: false },
  },
  methods: {
    execute() {
      this.$emit('onClick');
    },
  },
};
</script>
<style scoped>
.add-box {
  background: var(--background-up);
  width: 100%;
  font-weight: bold;
  border: 2px dashed #656565c7;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
  color: #575758;
  cursor: pointer;
  transition: filter 0.2s ease-in-out;
}

.add-box.design-two {
  background: #3a3c40;
  color: #5a5b5c;
}

.add-box:hover {
  filter: brightness(1.1);
}

.add-box i {
  font-size: 2.1em;
  margin-bottom: 18px;
}

@media screen and (max-width: 991px) {
  .add-box.mobile {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    padding: 20px;
  }

  .add-box.mobile i {
    margin-bottom: 0;
    font-size: 14px;
    margin-right: 10px;
  }
}
</style>
